import { render, staticRenderFns } from "./addMicroAppModal.vue?vue&type=template&id=1c31bdec&scoped=true"
import script from "./addMicroAppModal.vue?vue&type=script&lang=js"
export * from "./addMicroAppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31bdec",
  null
  
)

export default component.exports